import { HttpInterceptorFn } from '@angular/common/http';
import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

import { environment } from 'environments/environment';

import { DuplicateRequestService } from '../services';

export const duplicateRequestInterceptor: HttpInterceptorFn = (req, next) => {
    if (environment.production) {
        return next(req);
    }

    const service = inject(DuplicateRequestService);
    const destroyRef = inject(DestroyRef);

    const signature = service.generateRequestSignature(req);

    if (service.isRequestActive(signature)) {
        service.showDuplicateWarning(req);
    }

    service.addRequest(signature);

    return next(req).pipe(
        takeUntilDestroyed(destroyRef),
        catchError((error) => {
            service.removeRequest(signature);
            return throwError(() => error);
        }),
        finalize(() => {
            service.removeRequest(signature);
        }),
    );
};
